import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { AppSettings } from '../settings/app-settings.service';

@Component({
  selector: 'ca-edit-profile',
  templateUrl: 'edit-profile.component.html',
  styleUrls: ['edit-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditProfileComponent {
  protected _disabled = false;
  protected _loading = false;
  protected _changePassword: boolean;

  public get changePassword() {
    return this._changePassword;
  }

  public set changePassword(value: boolean) {
    this._changePassword = value;
    if (value) {
      this.userForm.addControl('password', this.passwordControl);
    } else {
      this.userForm.removeControl('password');
    }
  }

  passwordControl = new FormControl('', [
    Validators.minLength(this.settings.MIN_PASSWORD_LENGTH),
    Validators.required
  ]);
  firstNameControl = new FormControl(undefined, [Validators.required]);
  lastNameControl = new FormControl(undefined, [Validators.required]);
  profileImageControl = new FormControl(undefined);

  public userForm: FormGroup;

  @Input()
  set profile(value: any) {
    this.userForm.patchValue(value);
  }

  @Input()
  set disabled(val: boolean) {
    this._disabled = val;
    if (this._disabled) {
      this.userForm.disable();
    } else {
      this.userForm.enable();
    }
  }

  get disabled() {
    return this._disabled;
  }

  @Input()
  set loading(val: boolean) {
    this._loading = val;
    if (this._loading && !this.userForm.disabled) {
      this.userForm.disable();
    } else if (!this._loading && !this._disabled && this.userForm.disabled) {
      this.userForm.enable();
    }
  }

  get loading() {
    return this._loading;
  }

  @Input() error: string;
  @Output() save = new EventEmitter();

  constructor(public settings: AppSettings) {
    this.createForm();
  }

  createForm() {
    this.userForm = new FormGroup({
      firstName: this.firstNameControl,
      lastName: this.lastNameControl,
      profileImage: this.profileImageControl
    });
  }

  submit() {
    if (this.userForm.valid) {
      this.save.next(this.userForm.value);
    } else {
      // Highlight any errors
      this.userForm.markAsTouched();
      for (let control in this.userForm.controls) {
        this.userForm.get(control).markAsTouched();
      }
    }
  }
}
